import React from 'react';
import RemoteApp from '@/components/RemoteApp';
import platforms from './config';

type PlatformItem = (typeof platforms)[number];

interface MicroAppRouteProps {
  source: PlatformItem;
}

export function MicroAppRoute({ source }: MicroAppRouteProps) {
  if (!source.nebulaModule) {
    return null;
  }

  return (
    <RemoteApp
      moduleId={`${source.nebulaModule}/App`}
      basename={source.basename}
      isSubApp={source.isSubApp}
    />
  );
}

export default MicroAppRoute;
